/**
 * @generated SignedSource<<66a4f9d13d27125937bf5653f9cbc06b>>
 * @flow
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

/*::
import type { Fragment, ReaderFragment } from 'relay-runtime';
type UserAvatar_user$fragmentType = any;
export type JobEventActorType = "AGENT" | "DISPATCH" | "SYSTEM" | "USER" | "%future added value";
import type { FragmentType } from "relay-runtime";
declare export opaque type JobEventRetryFailed_event$fragmentType: FragmentType;
export type JobEventRetryFailed_event$data = {|
  +actor?: {|
    +node: ?{|
      +name?: string,
      +uuid?: string,
      +$fragmentSpreads: UserAvatar_user$fragmentType,
    |},
    +type: JobEventActorType,
  |},
  +retryFailedReason?: string,
  +timestamp?: any,
  +$fragmentType: JobEventRetryFailed_event$fragmentType,
|};
export type JobEventRetryFailed_event$key = {
  +$data?: JobEventRetryFailed_event$data,
  +$fragmentSpreads: JobEventRetryFailed_event$fragmentType,
  ...
};
*/

var node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "JobEventRetryFailed_event",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "timestamp",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "JobEventActor",
          "kind": "LinkedField",
          "name": "actor",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "type",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "uuid",
                      "storageKey": null
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "UserAvatar_user"
                    }
                  ],
                  "type": "User",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "retryFailedReason",
              "storageKey": null
            }
          ],
          "type": "JobEventRetryFailed",
          "abstractKey": null
        }
      ],
      "type": "JobEvent",
      "abstractKey": "__isJobEvent"
    }
  ],
  "type": "JobEventRetryFailed",
  "abstractKey": null
};

(node/*: any*/).hash = "1b7f6fd9d934ebda85cf68459fd4d81c";

module.exports = ((node/*: any*/)/*: Fragment<
  JobEventRetryFailed_event$fragmentType,
  JobEventRetryFailed_event$data,
>*/);
